import React, { Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import {getBrandingConfigs, deleteBrandingConfig,setBrandingPageInfo} from "../../actions/actionBranding";

class BrandingConfig extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            filterId: null
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteBrandingAction = this.deleteBrandingAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getBrandingConfigs();
    }

    deleteConfirm(brandingConfigId){
        this.setState({modal: !this.state.modal,
            brandingConfigId: brandingConfigId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteBrandingAction(){
        this.props.deleteBrandingConfig(this.state.brandingConfigId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteBrandingErrorMessage} = this.props;
        if(deleteBrandingErrorMessage) {
            NotificationManager.error(deleteBrandingErrorMessage,"Delete Branding Config Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Branding Config","Delete Branding Config", 3000);
            this.setState({modal: false});
            this.props.getBrandingConfigs();
        }
    }

    handleDeleteError(){
        const {deleteBrandingError} = this.props;
        if(deleteBrandingError){
            NotificationManager.error(deleteBrandingError,"Failed to Delete Branding Config", 3000);
            this.props.history.push("/branding");
        }else{
            NotificationManager.error("Failed to Delete Branding Config","Delete Branding Config", 3000);
            this.props.history.push("/banding");
        }
    }

    render() {
        if (this.props.getBrandingLoading) {
            return (<div> <LoadingSpinner /></div>);
        }

        const {branding_configs} = this.props;

        const tableColumns = [
            {
                type: "text",
                name: "Name",
                accessor: "name",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Hostname",
                accessor: "hostname",
                filterable: true,
                sortable: true,
            },
            {
                type: "flag",
                name: "Default",
                accessor: "is_default",
                filterable: true,
                sortable: true,
            },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewbranding/${item.branding_config_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updatebranding/${item.branding_config_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.branding_config_id);
                break;
            }
        }

        return(
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-paint-brush"></i> <strong>Branding Configurations</strong></div>
                                <Link className="pull-right add-btn" to={{ pathname: "/createbranding" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                        Add Config
                                    </button>
                                </Link>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="branding"
                                    data={branding_configs}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this config?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm" 
                        className="cancel-button"
                        color=" basic">Close</Button>
                        <Button onClick={this.deleteBrandingAction}
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
        branding_configs: state.branding.branding_configs || [],
        getBrandingLoading: state.branding.getBrandingLoading || false,
        getBrandingErrorMessage: state.branding.getBrandingErrorMessage || false,
        getBrandingError: state.branding.getBrandingError || null,
        deleteBrandingErrorMessage: state.branding.deleteBrandingErrorMessage || null,
        deleteBrandingError: state.branding.deleteBrandingError || null,
        deletedBranding: state.branding.deletedBranding || null,
        deleteBrandingLoading: state.branding.deleteBrandingLoading || null,
        pages : {pageSize : state.branding.pageSize, pageNo : state.branding.pageNo},
    }),
    dispatch => ({
        getBrandingConfigs: () => dispatch(getBrandingConfigs()),
        deleteBrandingConfig: (data) => dispatch(deleteBrandingConfig(data)),
        setPageInfo : (data)=> dispatch(setBrandingPageInfo(data)),
    }))(BrandingConfig);



// WEBPACK FOOTER //
// ./src/views/Branding/Branding.js